module.exports = __webpack_public_path__ + "static/media/id-popup-step3.3d4f4dd4.png";